import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { compararValoresOrdenacao } from '../../../shared/helpers/ordenacao-tabela.helper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { ProdutoListaRefinamentoEnum } from '../../../shared/enums/produto/produto-lista-refinamento.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { LookupService } from '../../../shared/services/apis/produto/produto-lookup.service';
import { MotorFiscalLookupService } from '../../../shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { ProdutoService } from '../../../shared/services/apis/produto/produto.service';
import { ProdutoOrquestradorService } from '@shared/services/apis/orquestrador-suprimentos/produto-orquestrador.service';
import { ProdutoListaRequest } from '../../../shared/services/requests/produto/produto-lista.request';
import { GetAllProdutoResponse } from '../../../shared/services/responses/produto/get-all-produto.response';
import { LookupItemStruct } from '../../../shared/services/structs/pessoa/lookup-item.struct';
import { UnidadeMedidaStruct } from '../../../shared/services/structs/produto/unidade-medida.struct';
import { TagListItem } from '../../../shared/services/structs/produto/tag-list-item.struct';
import { ProdutoListStruct } from '../../../shared/services/structs/produto/produto-list.struct';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { environment } from '../../../../environments/environment';
import { ConfiguracaoColunasModalComponent, ColunaConfiguracao } from '../../../shared/components/configuracao-colunas-modal/configuracao-colunas-modal.component';
import { TipoContatoEnum } from '../../../shared/enums/pessoa/tipo-contato.enum';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { UiTagComponent } from '../../../shared/components/ui-tag/ui-tag.component';
import { UtilService } from '../../../shared/services/util.service';
import { ExtracaoDadosData, ExtracaoDadosModalComponent, FiltroExtracao } from '../../../shared/components/extracao-dados-modal/extracao-dados-modal.component';
import { OrigemPedidoExportacaoEnum } from '../../../shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '../../../shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { ImpressaoProdutoListaSimplesComponent } from './dialogs/impressao-produto-lista-simples/impressao-produto-lista-simples.component';
import { AlterarTagsDialogComponent } from './dialogs/alterar-tags-dialog/alterar-tags-dialog.component';
import { EditarProdutosMassaDialogComponent } from './dialogs/editar-produtos-massa-dialog/editar-produtos-massa-dialog.component';
import { DialogImportarProdutosComponent } from './dialogs/importar-produtos/dialog-importar-produtos.component';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';
import { EtiquetaLookupService } from '../../../shared/services/apis/etiqueta/etiqueta-lookup.service';
import { Router } from '@angular/router';
import { ImprimirEtiquetasDialogComponent, ImprimirEtiquetasDialogData } from '../../../shared/components/imprimir-etiquetas-dialog/imprimir-etiquetas-dialog.component';
import { EtiquetaLookupItemStruct } from '../../../shared/services/structs/etiqueta/etiqueta-lookup-item.struct';
import { ListaPrecoStruct } from '../../../shared/services/structs/produto/lista-preco.struct';
import { LocalizacaoEstoque } from '../../../shared/services/models/produto/localizacao-estoque.model';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MaskService } from '../../../shared/services/mask.service';
import { SelectPesquisavelService } from '../../../shared/components/select-pesquisavel/select-pesquisavel.service';
import { PesquisaCodigoTributacaoModalComponent, PesquisaCodigoTributacaoModalData, PesquisaCodigoTributacaoModalResult } from '../../../shared/components/pesquisa-codigo-tributacao-modal/pesquisa-codigo-tributacao-modal.component';
import { catchError, map, of } from 'rxjs';
import { TipoEtiquetaEnum } from '@shared/enums/etiqueta/tipo-etiqueta.enum';

export interface ProdutoDisplayRow {
    data: ProdutoListStruct;
    isVariation: boolean;
}

@Component({
    selector: 'app-produto-lista',
    standalone: true,
    imports: [
        CommonModule,
        HeaderComponent,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatBadgeModule,
        MatTooltipModule,
        MatSelectModule,
        EmptyListComponent,
        SelectPesquisavelComponent,
        RouterModule,
        MatSortModule,
        LoadingBoxDefaultListComponent,
        NgxMaskPipe,
        NgxMaskDirective,
        AbntPipe,
        UiTagComponent
    ],
    providers: [provideNgxMask()],
    templateUrl: './produto-lista.component.html',
    styleUrls: ['./produto-lista.component.css'],
})
export class ProdutoListaComponent implements OnInit {

    // Enums for Menu and Permissions
    public moduloEnum = ModuloEnum.Cadastros;
    public funcionalidadeEnum = FuncionalidadeEnum.Cadastros_Produtos; // Make sure this Enum exists or map correctly
    public _produtoListaRefinamentoEnum = ProdutoListaRefinamentoEnum;

    public readonly masks = MaskService.getMasks();
    public readonly ncmLookupUrl = environment.urlApiMotorFiscal + 'Lookup/ncm';

    public model: FormGroup;
    public _isLoading: boolean = false;
    public filtroRefinar: number | null = null;
    public _isLoadingAction: boolean = false; // For bulk actions loading state
    public fornecedorSelecionado: any = null;

    // Lists for Filters
    public listaCategoria: LookupItemStruct[] = [];
    public listaMarca: LookupItemStruct[] = [];
    public listaTag: TagListItem[] = [];
    public listaTipoProduto: LookupItemStruct[] = [];
    public listaOrigemMercadoria: LookupItemStruct[] = [];
    public listaLinhaProduto: LookupItemStruct[] = [];
    public listaUnidadeMedida: UnidadeMedidaStruct[] = [];
    public listaTipoItemSped: LookupItemStruct[] = [];
    public listaPreco: ListaPrecoStruct[] = [];
    public listaLocalizacaoEstoque: LocalizacaoEstoque[] = [];

    // URL for dynamic lookups (like Fornecedor which is ID Pessoa)
    public urlFornecedor = `${environment.urlApiPessoa}Lookup/listPessoaSelect?idTipoContato=${TipoContatoEnum.Fornecedor}`;

    public loadLookups: boolean = false;

    // Data and Pagination
    public _listaProdutoResponse: GetAllProdutoResponse | undefined;
    public _dataSource = new MatTableDataSource<ProdutoListStruct>();
    public _flatDataSource = new MatTableDataSource<ProdutoDisplayRow>();
    public _paginaAtual: number = 0;
    public _ultimaPagina: boolean = false;
    public expandedElements = new Set<ProdutoListStruct>();

    public displayedColumns: string[] = []; // Initialized in init

    // Columns Definition
    public todosCampos: ColunaConfiguracao[] = [
        { def: 'select', label: 'Seleção', visible: true, fixed: true, pinnedStart: true },
        { def: 'descricao', label: 'Descrição', visible: true, fixed: false },
        { def: 'tipoProduto', label: 'Tipo de Produto', visible: true, fixed: false },
        { def: 'codigoSku', label: 'Código (SKU)', visible: false, fixed: false },
        { def: 'gtinEan', label: 'GTIN/EAN', visible: false, fixed: false },
        { def: 'unidade', label: 'Unidade', visible: false, fixed: false },
        { def: 'ncm', label: 'NCM', visible: false, fixed: false },
        { def: 'preco', label: 'Preço', visible: true, fixed: false },
        { def: 'custo', label: 'Custo', visible: false, fixed: false },
        { def: 'marca', label: 'Marca', visible: false, fixed: false },
        { def: 'codFornecedor', label: 'Cód Fornecedor', visible: false, fixed: false },
        { def: 'tags', label: 'Tag', visible: false, fixed: false },
        { def: 'estoqueFisico', label: 'Estoque Físico', visible: true, fixed: false },
        { def: 'estoqueDisponivel', label: 'Estoque Disponível', visible: true, fixed: false },
        { def: 'actions', label: 'Ações', visible: true, fixed: true, pinnedEnd: true },
    ];

    // Selection Control

    // Selection Control
    public selection = new SelectionModel<ProdutoListStruct>(true, []);

    // Ordenação atual (aplicada aos produtos-pai; as variações seguem o pai).
    private _sortAtual: Sort | null = null;

    public onSortChange(sort: Sort): void {
        this._sortAtual = sort;
        this.reconstruirFlatDataSource();
    }

    constructor(
        private formBuilder: FormBuilder,
        private produtoService: ProdutoService,
        private produtoOrquestradorService: ProdutoOrquestradorService,
        private lookupService: LookupService, // This is Produto Lookup Service
        private motorFiscalLookupService: MotorFiscalLookupService,
        private alertService: AlertService,
        private dialog: MatDialog,
        private utilService: UtilService,
        private etiquetaLookupService: EtiquetaLookupService,
        private router: Router,
        private selectPesquisavelService: SelectPesquisavelService,
        private authService: AuthService
    ) { }

    public onNcmKeydown(event: KeyboardEvent): void {
        const allowed = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        const isShortcut = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
        if (allowed.includes(event.key) || isShortcut) return;
        if (!/^\d$/.test(event.key)) { event.preventDefault(); }
    }

    public formatNcm(codigo: string): string {
        const d = (codigo || '').replace(/\D/g, '');
        if (d.length <= 4) return d;
        if (d.length <= 6) return `${d.slice(0, 4)}.${d.slice(4)}`;
        return `${d.slice(0, 4)}.${d.slice(4, 6)}.${d.slice(6)}`;
    }

    public pesquisarNcm(): void {
        const dialogRef = this.dialog.open(PesquisaCodigoTributacaoModalComponent, {
            width: '700px',
            maxHeight: '85vh',
            panelClass: 'pesquisa-codigo-tributacao-dialog',
            data: {
                titulo: 'Pesquisar NCM',
                buscarFn: (pesquisa: string) =>
                    this.selectPesquisavelService.getSelectValues<any>(this.ncmLookupUrl, pesquisa).pipe(
                        map(list => ({
                            isError: false,
                            itens: list.map((i: any) => ({ codigo: this.formatNcm(String(i.codigo ?? '')), descricao: i.descricao })),
                        })),
                        catchError(() => of({ isError: true, itens: [] })),
                    ),
                permitirManual: false,
                registrosIniciais: 20,
            } as PesquisaCodigoTributacaoModalData,
        });
        dialogRef.afterClosed().subscribe((result: PesquisaCodigoTributacaoModalResult | null) => {
            if (!result?.selecionado) return;
            const codigo = result.selecionado.codigo.replace(/\D/g, '');
            this.model.get('ncm')?.setValue(codigo);
        });
    }

    ngOnInit(): void {
        this.model = this.formBuilder.group({
            pesquisa: [''],
            // Advanced Filters
            idCategoria: [null],
            idFornecedor: [null],
            idMarca: [null],
            ncm: [''],
            listIdTag: [[]], // Multiple selection
            listIdTipoProduto: [[]] // Multiple selection
        });

        this.carregarLookups();
        this.atualizarColunasVisiveis();
        this.loadFilters();
        this.pesquisar();
    }

    ngOnDestroy(): void {
        this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, ['/cadastros/produtos/cadastrar']);
    }

    private loadFilters(): void {
        const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
        if (filtroSalvo) {
            this.model.patchValue(filtroSalvo);
        }
    }

    private atualizarColunasVisiveis(): void {
        this.displayedColumns = this.todosCampos
            .filter(c => c.visible)
            .map(c => c.def);
    }

    // ... (existing code)

    public configurarColunas() {
        const dialogRef = this.dialog.open(ConfiguracaoColunasModalComponent, {
            maxWidth: '700px',
            data: { colunas: this.todosCampos }
        });

        dialogRef.afterClosed().subscribe((result: ColunaConfiguracao[]) => {
            if (result) {
                this.todosCampos = result;
                this.atualizarColunasVisiveis();
            }
        });
    }

    private carregarLookups(): void {
        // Tipo de Item SPED e Origem da Mercadoria são obtidos de db_motor_fiscal via API MotorFiscal.
        this.motorFiscalLookupService.getLookup().subscribe({
            next: (res) => {
                if (!res.isError) {
                    this.listaTipoItemSped = res.listaTipoItemSped || [];
                    this.listaOrigemMercadoria = res.listaOrigemMercadoria || [];
                }
            },
        });

        this.loadLookups = true;
        this.lookupService.getLookup().subscribe({
            next: (res) => {
                if (!res.isError) {
                    this.listaCategoria = res.listaCategoria || [];
                    this.listaMarca = res.listaMarca || [];
                    this.listaTag = res.listaTag || [];
                    this.listaTipoProduto = res.listaTipoProduto || [];
                    this.listaLinhaProduto = res.listaLinhaProduto || [];
                    this.listaUnidadeMedida = res.listaUnidadeMedida || [];
                    this.listaPreco = res.listaPreco || [];
                    this.listaLocalizacaoEstoque = res.listaLocalizacaoEstoque || [];
                }
                this.loadLookups = false;
            },
            error: () => this.loadLookups = false
        });
    }

    // --- Search and Pagination Logic ---

    public pesquisar(): void {
        if (this._isLoading) return;

        this._isLoading = true;

        const request = this.getFiltrosRequest();

        this.produtoService.getAll(request, this._paginaAtual).subscribe({
            next: (response: GetAllProdutoResponse) => {
                this._isLoading = false;
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    return;
                }

                if (!this._listaProdutoResponse) {
                    this._listaProdutoResponse = response;
                    this._dataSource.data = response.list;
                } else {
                    this._listaProdutoResponse.list.push(...response.list);
                    this._dataSource.data = this._listaProdutoResponse.list;
                }
                this.reconstruirFlatDataSource();

                this._ultimaPagina = !response.list?.length ||
                    this._dataSource.data.length >= response.fullListSize;
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    public clickPesquisar(): void {
        this._paginaAtual = 0;
        this._listaProdutoResponse = undefined;
        this._dataSource.data = [];
        this._flatDataSource.data = [];
        this._ultimaPagina = false;
        this.expandedElements.clear();
        this.selection.clear();
        this.pesquisar();
    }

    public aplicarFiltros(): void {
        this.clickPesquisar();
    }

    public proximaPagina(): void {
        this._paginaAtual++;
        this.pesquisar();
    }

    public limparFiltros(): void {
        this.model.patchValue({
            pesquisa: '',
            idCategoria: null,
            idFornecedor: null,
            idMarca: null,
            ncm: '',
            listIdTag: [],
            listIdTipoProduto: []
        });
        this.filtroRefinar = null;
        this.clickPesquisar();
    }

    // --- Selection Logic ---

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        let totalItems = 0;
        for (const produto of this._dataSource.data) {
            totalItems++;
            if (produto.variacoes?.length) {
                totalItems += produto.variacoes.length;
            }
        }
        return numSelected === totalItems && totalItems > 0;
    }

    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }
        const allItems: ProdutoListStruct[] = [];
        for (const produto of this._dataSource.data) {
            allItems.push(produto);
            if (produto.variacoes?.length) {
                allItems.push(...produto.variacoes);
            }
        }
        this.selection.select(...allItems);
    }

    toggleSelection(item: ProdutoListStruct): void {
        this.selection.toggle(item);
        // Se é um pai, aplicar cascata nas variações
        if (item.variacoes?.length) {
            if (this.selection.isSelected(item)) {
                this.selection.select(...item.variacoes);
            } else {
                this.selection.deselect(...item.variacoes);
            }
        }
    }

    checkboxLabel(row?: ProdutoListStruct): string {
        if (!row) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.idProduto}`;
    }

    public toggleRow(row: ProdutoDisplayRow): void {
        const element = row.data;
        if (row.isVariation) return;
        if (element.variacoes && element.variacoes.length > 0) {
            this.toggleExpand(element);
            this.reconstruirFlatDataSource();
        }
    }

    public toggleExpand(produto: ProdutoListStruct): void {
        if (this.expandedElements.has(produto)) {
            this.expandedElements.delete(produto);
        } else {
            this.expandedElements.add(produto);
        }
    }

    public reconstruirFlatDataSource(): void {
        // Ordena os produtos-pai conforme a coluna selecionada e mantém as
        // variações logo abaixo do respectivo pai.
        if (this._sortAtual?.active && this._sortAtual.direction) {
            this._dataSource.data = this.ordenarProdutos(this._dataSource.data);
        }

        const flat: ProdutoDisplayRow[] = [];
        for (const produto of this._dataSource.data) {
            flat.push({ data: produto, isVariation: false });
            if (this.expandedElements.has(produto) && produto.variacoes?.length) {
                for (const variacao of produto.variacoes) {
                    flat.push({ data: variacao, isVariation: true });
                }
            }
        }
        this._flatDataSource.data = flat;
    }

    private ordenarProdutos(produtos: ProdutoListStruct[]): ProdutoListStruct[] {
        const sort = this._sortAtual;
        if (!sort || !sort.active || !sort.direction) {
            return produtos;
        }
        const dir = sort.direction === 'asc' ? 1 : -1;
        return [...produtos].sort((a, b) => {
            const ra = this.getValorOrdenacao(a, sort.active);
            const rb = this.getValorOrdenacao(b, sort.active);
            if (ra == null && rb == null) return 0;
            if (ra == null) return -dir;
            if (rb == null) return dir;
            return compararValoresOrdenacao(ra, rb) * dir;
        });
    }

    private getValorOrdenacao(produto: ProdutoListStruct, coluna: string): string | number | null | undefined {
        switch (coluna) {
            case 'estoqueFisico':
                return produto.saldoFisico;
            case 'estoqueDisponivel':
                return produto.saldoDisponivel;
            default:
                return (produto as unknown as Record<string, any>)[coluna];
        }
    }

    // --- Helper Methods ---

    public getFiltrosRequest(): ProdutoListaRequest {
        const request = new ProdutoListaRequest();
        request.searchText = this.model.get('pesquisa')?.value;

        // Advanced Filters mapping
        request.idCategoria = this.model.get('idCategoria')?.value;
        request.idFornecedor = this.model.get('idFornecedor')?.value;
        request.idMarca = this.model.get('idMarca')?.value;
        request.ncm = this.model.get('ncm')?.value;
        request.listIdTag = this.model.get('listIdTag')?.value;
        request.listIdTipoProduto = this.model.get('listIdTipoProduto')?.value;

        if (this.filtroRefinar) {
            request.idProdutoListaRefinamento = this.filtroRefinar;
        }

        return request;
    }

    // --- Actions ---

    public abrirModalExcluir(produto?: ProdutoListStruct): void {
        const isLote = !produto;
        const listaParaExcluir = isLote ? this.selection.selected : [produto!];

        if (listaParaExcluir.length === 0) {
            this.alertService.show('Atenção', 'Nenhum produto selecionado.', AlertType.warning);
            return;
        }

        const descricao = isLote
            ? `Confirma a exclusão de ${listaParaExcluir.length} produtos selecionados?`
            : `Confirma a exclusão do produto ${produto?.descricao}?`;

        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Confirmação de Exclusão',
                description: descricao,
                buttonConfirm: 'Confirmar',
                buttonClose: 'Cancelar',
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.confirm) {
                this.processarExclusao(listaParaExcluir);
            }
        });
    }

    private processarExclusao(lista: ProdutoListStruct[]): void {
        this._isLoadingAction = true;
        const listIdProduto: number[] = lista.map(x => x.idProduto);

        if (listIdProduto.length > 0) {
            // Pelo orquestrador: recusa o produto usado em ordem de produção, venda, compra ou NF-e (bug 151221).
            this.produtoOrquestradorService.excluir({ idsProduto: listIdProduto }).subscribe({
                next: (res) => {
                    this._isLoadingAction = false;
                    if (res.isError) {
                        if (res.errorCode == 2) {
                            const dialogRef = this.dialog.open(ConfirmModalComponent, {
                                data: {
                                    title: 'Exclusão interrompida!',
                                    description: res.errorDescription,
                                    buttonClose: 'Fechar',
                                }
                            });
                        }
                        else {
                            this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                        }
                        return;
                    }
                    this.alertService.show('Sucesso', 'Exclusão realizada.', AlertType.success);
                    this.clickPesquisar();
                },
                error: (err) => {
                    this._isLoadingAction = false;
                    this.alertService.show('Erro', 'Falha ao excluir.', AlertType.error);
                }
            })
        }
    }

    public get qtdFiltrosAvancados(): number {
        let count = 0;
        const formValue = this.model.getRawValue();

        if (formValue.idCategoria) count++;
        if (formValue.idFornecedor) count++;
        if (formValue.idMarca) count++;
        if (formValue.ncm) count++;
        if (formValue.listIdTag && formValue.listIdTag.length > 0) count++;
        if (formValue.listIdTipoProduto && formValue.listIdTipoProduto.length > 0) count++;

        return count;
    }

    public exportarProdutos() {
        if (this._isLoadingAction) return;

        const formValue = this.model.getRawValue();
        const filtrosMapeados: FiltroExtracao[] = [];

        if (formValue.pesquisa) {
            filtrosMapeados.push({ label: 'Pesquisa', formControlName: 'searchText', valor: formValue.pesquisa });
        }
        if (formValue.idCategoria) {
            const categoria = this.listaCategoria.find(c => c.id === formValue.idCategoria);
            filtrosMapeados.push({ label: 'Categoria', formControlName: 'idCategoria', valor: formValue.idCategoria, valorExibicao: categoria ? categoria.descricao : formValue.idCategoria });
        }
        if (formValue.idFornecedor) {
            filtrosMapeados.push({ label: 'Fornecedor', formControlName: 'idFornecedor', valor: formValue.idFornecedor, valorExibicao: this.fornecedorSelecionado ? this.fornecedorSelecionado.descricao : formValue.idFornecedor });
        }
        if (formValue.idMarca) {
            const marca = this.listaMarca.find(m => m.id === formValue.idMarca);
            filtrosMapeados.push({ label: 'Marca', formControlName: 'idMarca', valor: formValue.idMarca, valorExibicao: marca ? marca.descricao : formValue.idMarca });
        }
        if (formValue.ncm) {
            filtrosMapeados.push({ label: 'NCM', formControlName: 'ncm', valor: formValue.ncm });
        }
        if (formValue.listIdTag && formValue.listIdTag.length > 0) {
            const tags = formValue.listIdTag.map((id: number) => {
                const tag = this.listaTag.find(t => t.idTag === id);
                return tag ? tag.nome : id;
            }).join(', ');
            filtrosMapeados.push({ label: 'Tags', formControlName: 'listIdTag', valor: formValue.listIdTag, valorExibicao: tags });
        }
        if (formValue.listIdTipoProduto && formValue.listIdTipoProduto.length > 0) {
            const tipos = formValue.listIdTipoProduto.map((id: number) => {
                const tipo = this.listaTipoProduto.find(t => t.id === id);
                return tipo ? tipo.descricao : id;
            }).join(', ');
            filtrosMapeados.push({ label: 'Tipo de Produto', formControlName: 'listIdTipoProduto', valor: formValue.listIdTipoProduto, valorExibicao: tipos });
        }
        if (this.filtroRefinar) {
            let labelRefinamento = 'Outro';
            if (this.filtroRefinar === this._produtoListaRefinamentoEnum.CodigoSku) labelRefinamento = 'Código SKU';
            else if (this.filtroRefinar === this._produtoListaRefinamentoEnum.CodigoFornecedor) labelRefinamento = 'Código Fornecedor';
            else if (this.filtroRefinar === this._produtoListaRefinamentoEnum.GtinEan) labelRefinamento = 'GTIN/EAN';
            else if (this.filtroRefinar === this._produtoListaRefinamentoEnum.Descricao) labelRefinamento = 'Descrição';
            else if (this.filtroRefinar === this._produtoListaRefinamentoEnum.PalavrasChave) labelRefinamento = 'Palavras-chave';

            filtrosMapeados.push({ label: 'Refinar por', formControlName: 'idPessoaListaRefinamento', valor: this.filtroRefinar, valorExibicao: labelRefinamento });
        }

        const dialogData: ExtracaoDadosData = {
            titulo: 'Exportar Produtos',
            tipoExtracao: TipoExtracaoEnum.ProdutosCSV,
            origemPedidoExportacao: OrigemPedidoExportacaoEnum.CadastrosProdutos,
            filtros: filtrosMapeados,
            possuiAutomacao: false,
        };

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: dialogData,
            panelClass: 'extracao-dados-panel',
            disableClose: true
        });
    }

    public exportarKits() {
        if (this._isLoadingAction) return;

        const dialogData: ExtracaoDadosData = {
            titulo: 'Exportação de Composição de Kits',
            tipoExtracao: TipoExtracaoEnum.ComposicaoKitsCSV,
            origemPedidoExportacao: OrigemPedidoExportacaoEnum.CadastrosProdutos,
            filtros: [],
            possuiAutomacao: false,
        };

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: dialogData,
            panelClass: 'extracao-dados-panel',
            disableClose: true
        });
    }

    public exportarFabricados() {
        if (this._isLoadingAction) return;

        const dialogData: ExtracaoDadosData = {
            titulo: 'Exportação de Estrutura de Fabricados',
            tipoExtracao: TipoExtracaoEnum.EstruturaFabricadosCSV,
            origemPedidoExportacao: OrigemPedidoExportacaoEnum.CadastrosProdutos,
            filtros: [],
            possuiAutomacao: false,
        };

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: dialogData,
            panelClass: 'extracao-dados-panel',
            disableClose: true
        });
    }

    public changeFornecedor(item: any) {
        this.fornecedorSelecionado = item;
    }

    public imprimirRelatorio(): void {
        const filtros = this.getFiltrosRequest();
        if (this.selection.hasValue()) {
            filtros.produtoIdsList = this.selection.selected.map(p => p.idProduto);
        }
        this.dialog.open(ImpressaoProdutoListaSimplesComponent, {
            data: { filtros },
            maxWidth: '90vw',
            disableClose: false
        });
    }
    public importarProdutos(): void {
        const dialogRef = this.dialog.open(DialogImportarProdutosComponent, {
            maxWidth: '95vw',
            width: '95vw',
            maxHeight: '95vh',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.clickPesquisar();
            }
        });
    }
    public editarEmMassa() {
        if (this.selection.selected.length === 0) {
            this.alertService.show('Atenção', 'Selecione ao menos um produto para editar em massa.', AlertType.warning);
            return;
        }

        const listaProdutoIds = this.selection.selected.map(p => p.idProduto);

        const dialogRef = this.dialog.open(EditarProdutosMassaDialogComponent, {
            maxWidth: '90vw',
            maxHeight: '90vh',
            disableClose: false,
            data: {
                listaProdutoIds: listaProdutoIds,
                listaUnidadeMedida: this.listaUnidadeMedida,
                listaOrigemMercadoria: this.listaOrigemMercadoria,
                listaCategoria: this.listaCategoria,
                listaMarca: this.listaMarca,
                listaLinhaProduto: this.listaLinhaProduto,
                listaTipoItemSped: this.listaTipoItemSped
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.success) {
                this.clickPesquisar();
            }
        });
    }
    public alterarTags(): void {
        if (this.selection.selected.length === 0) {
            this.alertService.show('Atenção', 'Selecione ao menos um produto para alterar tags.', AlertType.warning);
            return;
        }

        const listaProdutoIds = this.selection.selected.map(p => p.idProduto);

        const dialogRef = this.dialog.open(AlterarTagsDialogComponent, {
            width: '600px',
            maxHeight: '90vh',
            disableClose: false,
            data: {
                listaProdutoIds: listaProdutoIds,
                listaTag: this.listaTag
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.success) {
                this.clickPesquisar();
            }
        });
    }

    public imprimirEtiquetas(produto?: ProdutoListStruct): void {
        const listaProdutos = produto ? [produto] : this.selection.selected;

        if (listaProdutos.length === 0) {
            this.alertService.show('Atenção', 'Selecione ao menos um produto para imprimir etiquetas.', AlertType.warning);
            return;
        }

        this._isLoadingAction = true;
        this.etiquetaLookupService.listEtiquetaSelect(undefined, TipoEtiquetaEnum.Produto).subscribe({
            next: (res) => {
                this._isLoadingAction = false;
                if (res.isError) {
                    this.alertService.show('Erro', res.errorDescription, AlertType.error);
                    return;
                }

                if (!res.list || res.list.length === 0) {
                    this.exibirAlertaSemConfiguracao();
                    return;
                }

                this.abrirModalImprimirEtiquetas(listaProdutos, res.list);
            },
            error: () => {
                this._isLoadingAction = false;
                this.alertService.show('Erro', 'Falha ao verificar configurações de etiqueta.', AlertType.error);
            }
        });
    }

    private exibirAlertaSemConfiguracao(): void {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Configuração necessária',
                description: 'Para imprimir as etiquetas é necessário realizar as configurações. Você pode fazer isso acessando Configurações > Configurações das etiquetas ou clicando no botão configurar etiquetas.',
                buttonConfirm: 'Configurar etiquetas',
                buttonClose: 'Cancelar',
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.confirm) {
                // AuthGuard bloqueia silenciosamente (redireciona pra /home) se o usuário não
                // tiver acesso ao módulo Configurações — sem isto, o modal só "fecha sem avisar".
                const temAcessoConfiguracoes = this.authService.getUserInfos()
                    .listaModulos?.some(m => m.idModulo === ModuloEnum.Configuracoes);

                if (!temAcessoConfiguracoes) {
                    this.alertService.show(
                        'Sem permissão',
                        'Você não tem permissão para acessar as configurações de etiquetas. Solicite acesso a um administrador.',
                        AlertType.warning
                    );
                    return;
                }

                this.router.navigate(['/configuracoes/gerais/etiquetas']);
            }
        });
    }

    private abrirModalImprimirEtiquetas(listaProdutos: ProdutoListStruct[], listaConfiguracoes: EtiquetaLookupItemStruct[]): void {
        const dialogData: ImprimirEtiquetasDialogData = {
            listaProdutos,
            listaConfiguracoes,
            listaPrecos: this.listaPreco,
            listaLocalizacaoEstoque: this.listaLocalizacaoEstoque,
        };

        this.dialog.open(ImprimirEtiquetasDialogComponent, {
            width: '900px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            disableClose: false,
            data: dialogData
        });
    }
}
